import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { AhaSection } from '../components/AhaSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { SystemIncludesSection } from '../components/SystemIncludesSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { ValidationBar } from '../components/ValidationBar';
export function LandingPage() {
  return <div className="min-h-screen bg-[#F5F1EA] font-body text-[#2D3648] overflow-x-hidden" data-id="element-189">
      <ValidationBar data-id="element-190" />
      <HeroSection data-id="element-191" />
      <PainSection data-id="element-192" />
      <AhaSection data-id="element-193" />
      <HowItWorksSection data-id="element-194" />
      <WhatYouGetSection data-id="element-195" />
      <SystemIncludesSection data-id="element-196" />
      <BonusSection data-id="element-197" />
      <PricingSection data-id="element-198" />
      <TestimonialsSection data-id="element-199" />
      <GuaranteeSection data-id="element-200" />
      <FAQSection data-id="element-201" />
      <FinalCTASection data-id="element-202" />

      {/* Footer simple */}
      <footer className="py-8 text-center text-[#8B6F5C] text-sm bg-[#F5F1EA] border-t border-[#5C6B60]/10" data-id="element-203">
        <p data-id="element-204">
          © 2024 Programa de Activación Lectora. Todos los derechos reservados.
        </p>
      </footer>

      <SocialProofPopup data-id="element-205" />
    </div>;
}